import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';

import { mutation as insertTagMutation, buildVariables as buildInsertVariables } from './insert-tag-mutation-builder';

import { TAGS_WITH_PIPELINE_COUNT_QUERY } from '../tags-with-pipeline-count-query-builder';
import { TAGS_QUERY } from '../useQueryTags';

export default function useInsertTag(options = {}) {
  const [executeMutation, response] = useMutation(insertTagMutation, {
    context: { permission: permissions.writeTags },
    successMsg: 'Tag created.',
    refetchQueries: [TAGS_WITH_PIPELINE_COUNT_QUERY, TAGS_QUERY],
    ...options,
  });

  const insertTag = ({ label, type }) => {
    return executeMutation(buildVariables({ label, type }));
  };

  return [insertTag, response];
}

function buildVariables({ label, type }) {
  return {
    variables: buildInsertVariables({ label, type }),
  };
}
